/**
 * Same {error:[{field,messages}]} shape as SettingsPage/errorHelpers.js
 * (AppExceptionRenderer.php). EditForm.php has no server-side validation on
 * `name` today, so field errors realistically only ever come back generic;
 * parseGeneralError covers the save-failure and delete-failure footer slots.
 */
export function parseGeneralError(error, fallback) {
  const data = error?.response?.data;
  const entries = Array.isArray(data?.error) ? data.error : [];
  const messages = entries.flatMap((entry) => entry.messages || []);

  if (messages.length) {
    return messages.join(" ");
  }

  return data?.message || error?.message || fallback;
}
